import {formatNumber} from "../../../components/FormatNumber";
import {Type} from "../helper";
import {copyPaymentTermsForInvoiceBill} from "./helper/copyPaymentTermsForInvoiceBill";
import {copyLinkItems} from "./helper/copyLinkItems";
import {PageType} from "../../../enums/PageType";
import {copyCustomFields} from "./helper/copyCustomFields";
import {getInitData} from "./helper/getInitData";
import {deleteAllIds} from "./helper/deleteAllIds";
import { select } from "redux-saga/effects";
// import { processFormItems } from "./helper/processFormItems";
import { showConfirmationModalPromise } from './helper/Modal/showConfirmationModalPromise';
import { SubscriptionCheck } from "../../../components/Access/helper/subscription/SubscriptionCheck";
import { SubscriptionScopeKey } from "../../../components/Access/helper/subscription/enum/SubscriptionScopeKey";
// import { processItemsMultiUom, processItemsMultiOther } from "./helper/processItemsMultiSeries";
import _ from "lodash";
import { readAutosaveStorage } from "../../LocalStorage/helpers/AutosaveTransactions/readStorage";
import { showWillOverrideAutosaveDataPromise } from "./helper/Modal/showWillOverrideAutosaveDataPromise";
import { processItems } from "./helper/processItems";
import { readOutstanding } from "./helper/readOutstanding";
import { put } from "../../../shared/SagaService";
import TransactionActions from "bukku/redux/Transaction/actions";

const {
    changeLinkItems,
} = TransactionActions;

// Case 3: Duplicate
// - Same Type
export function* duplicate(transactionType, originType, originTransaction = {}) {
    // Check if there's any autosaved data for the transaction type, and prompt modal if there is
    const { data, last_saved } = yield readAutosaveStorage(transactionType) || {};

    if (data) {
        const autosaveModalRef = yield select(state => state.Transaction.autosaveModalRef);
        const isProceed = yield showWillOverrideAutosaveDataPromise(transactionType, autosaveModalRef, last_saved, 'duplicate');
        if (!isProceed)
            return {isProceed: false, transaction: null};
    }

    // Init Data
    const initData = yield getInitData(transactionType);
    const settings = yield select(state => state.List.settings);
    const productList = yield select(state => state.List.productList);
    const companyCurrencyCode = yield select(state => state.Auth.companyCurrencyCode);

    const hasTagSub = SubscriptionCheck.withKeys(SubscriptionScopeKey.TAG).hasSubscriptionTo();
    const hasMultiCurrencySub =
        SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_CURRENCY).hasSubscriptionTo();
    const hasCustomFieldSub =
        SubscriptionCheck.withKeys(SubscriptionScopeKey.CUSTOM_FIELD).hasSubscriptionTo();

    // Payment Terms (Invoice, Bills)
    const termItems = yield copyPaymentTermsForInvoiceBill(transactionType, originTransaction);

    // Link Items
    const {
        linkItems,
        salesLinkItems,
        purchaseLinkItems,
    } = yield copyLinkItems(PageType.duplicate, transactionType, originTransaction);

    // Custom Fields
    const fields = yield copyCustomFields(transactionType, originType, originTransaction);

    const transaction = {
        ...initData,
        ...originTransaction,
        type: transactionType,

        // Copy from initData
        number: initData.number,
        date: initData.date,
        status: initData.status,

        due_date: initData.due_date, // For bill
        currency_code: hasMultiCurrencySub ? originTransaction.currency_code : companyCurrencyCode,
        exchange_rate: hasMultiCurrencySub ? originTransaction.exchange_rate : 1,

        term_items: termItems,
        link_items: linkItems,
        sales_link_items: salesLinkItems,
        purchase_link_items: purchaseLinkItems,
        fields: hasCustomFieldSub ? fields || [] : undefined,

        linked_items: [],

        // Copy from originTransaction
        // number2: originTransaction.number,
        amount: formatNumber(originTransaction.amount, 2, undefined, false),
        account2_id: originTransaction.account2_id || initData.account2_id,

        // Check subscription
        tag_ids: hasTagSub ? originTransaction.tag_ids || [] : undefined,
    };

    const hasTagChange = !_.isEqual(originTransaction.tag_ids || [], transaction.tag_ids || []);
    const hasCurrencyCodeChange = originTransaction.currency_code !== transaction.currency_code;
    // compare the 2 transactions' fields without 'id'
    // fields.length === 0 means that the 2 transactions don't share any same fields
    // const hasFieldChange = (fields || []).length === 0 ? false : _.differenceWith(
    //     originTransaction.fields,
    //     transaction.fields,
    //     (a, b) => _.isEqual(_.omit(a, 'id'), _.omit(b, 'id'))).length !== 0;
    const hasFieldChange = !hasCustomFieldSub && !!(fields || []).find(f => f.value);

    let finalFormItems = transaction.form_items || transaction.items || transaction.bank_items;
    // let nonBaseUomItems, removedBundles;
    // let hasTaxChange, hasLocationChange;

    // Form Items
    // if (transaction.form_items) {
    //     // Handle UOM, Tax, Location
    //     const {
    //         // processedFormItems,
    //         finalFormItems: finalFormItemsFunc,
    //         nonBaseUomItems: nonBaseUomItemsFunc,
    //         hasTaxChange: hasTaxChangeFunc,
    //         hasLocationChange: hasLocationChangeFunc,
    //         removedBundles: removedBundlesFunc,
    //     } = processFormItems({ formItems: transaction.form_items || [], productList, settings });

    //     finalFormItems = finalFormItemsFunc;
    //     hasTaxChange = hasTaxChangeFunc;
    //     hasLocationChange = hasLocationChangeFunc;
    //     nonBaseUomItems = nonBaseUomItemsFunc;
    //     removedBundles = removedBundlesFunc;
    // }

    // // Stock Adjustment and Stock Transfer
    // if (transaction.items) {
    //     const {
    //         newItems: postUOMFormItems,
    //         nonBaseUomItems: nonBaseUomItemsFunc,
    //     } = processItemsMultiUom({ items: transaction.items, productList });

    //     const {
    //         newItems: finalFormItemsFunc,
    //         hasLocationChange: hasLocationChangeFunc,
    //     } = processItemsMultiOther({ items: postUOMFormItems, settings });

    //     finalFormItems = finalFormItemsFunc;
    //     hasLocationChange = hasLocationChangeFunc;
    //     nonBaseUomItems = nonBaseUomItemsFunc;

    //     // if (nonBaseUomItems?.length || hasLocationChange) {
    //     //     // const invalidUoms = Array.from(new Set(nonBaseUomItems.map(i => i.product_unit_label)));
    //     //     // yield to make the Modal.confirm synchronous by using Promise
    //     //     yield showConfirmationModalPromise(nonBaseUomItems, {hasLocationChange})
    //     //         .then(() => {
    //     //             // User clicked OK - remove invalid form items with non-base UOM
    //     //             transaction.items = finalFormItems;
    //     //             shownModal = true;
    //     //         });
    //     // }
    // }

    // // Bank Income and Expense
    // if (transaction.bank_items) {
    //     const {
    //         newItems: finalFormItemsFunc,
    //         hasTaxChange: hasTaxChangeFunc,
    //     } = processItemsMultiOther({ items: transaction.bank_items, settings });

    //     finalFormItems = finalFormItemsFunc;
    //     hasTaxChange = hasTaxChangeFunc;
    //     // nonBaseUomItems = nonBaseUomItemsFunc;
    // }

    // Process form_items/bank_items/items
    const {
        finalFormItems: finalFormItemsFunc,

        hasTaxChange: hasTaxChangeFunc,
        hasLocationChange: hasLocationChangeFunc,

        nonBaseUomItems: nonBaseUomItemsFunc,
        removedBundles: removedBundlesFunc,

        hasItemsChange: hasItemsChangeFunc,
    } = processItems({ transaction, productList, settings});

    finalFormItems = finalFormItemsFunc;
    const hasTaxChange = hasTaxChangeFunc;
    const hasLocationChange = hasLocationChangeFunc;
    const nonBaseUomItems = nonBaseUomItemsFunc;
    const removedBundles = removedBundlesFunc;

    const hasNonSubscribedFeatures = hasItemsChangeFunc ||
        hasTagChange || hasCurrencyCodeChange || hasFieldChange;

    const replaceItems = newItems => {
        if (originTransaction.form_items)
            transaction.form_items = newItems;
        else if (originTransaction.items)
            transaction.items = newItems;
        else if (originTransaction.bank_items)
            transaction.bank_items = newItems;
    };

    if (hasNonSubscribedFeatures) {
        yield showConfirmationModalPromise(
            nonBaseUomItems,
            removedBundles,
            {
                hasTagChange, hasCurrencyCodeChange, hasFieldChange, hasLocationChange, hasTaxChange,
            })
            .then(() => {
                // User clicked OK - remove invalid form items with non-base UOM (if no multi UOM sub)
                replaceItems(finalFormItems);
            });
    }
    // all features are subscribed - replace with processed items directly
    else {
        replaceItems(finalFormItems);
    }

    // For Sale Refund / Purchase Refund
    if ([Type.sale_refund, Type.purchase_refund].includes(transactionType))
        transaction.fee_amount = undefined;

    // For Invoices and Bills, read outstanding transactions
    if ([Type.sale_invoice, Type.purchase_bill].includes(transactionType)) {
        const txnTypeToRead =
        transactionType === Type.sale_invoice ? Type.sale_refund : Type.purchase_refund;

        yield readOutstanding(PageType.duplicate, txnTypeToRead, transaction);
        const fetchedLinkItems = yield select(state => state.Transaction.linkItems);

        transaction.link_items = fetchedLinkItems;
        yield put(changeLinkItems(fetchedLinkItems));
    }

    // return deleteAllIds(transaction);
    // Remove all ids
    return {
        isProceed: true,
        transaction: deleteAllIds(transaction),
    };
}
